// extracted by mini-css-extract-plugin
export default {"container_manut_servs":"ManutencaoServicos_container_manut_servs__Q4GF4","campos_linha":"ManutencaoServicos_campos_linha__DgAsA","btnEdit":"ManutencaoServicos_btnEdit__iWhS8"};